import { render, staticRenderFns } from "./EducationalServices.vue?vue&type=template&id=61db3a98&scoped=true"
import script from "./EducationalServices.vue?vue&type=script&lang=js"
export * from "./EducationalServices.vue?vue&type=script&lang=js"
import style0 from "./EducationalServices.vue?vue&type=style&index=0&id=61db3a98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db3a98",
  null
  
)

export default component.exports